module.exports = __webpack_public_path__ + "img/博志生物科技.87ecb1ed.png";